import adminApi from './adminApi';

const integrationAdminApi = {
  async listMerchants(params = {}) {
    const { data } = await adminApi.get('/api/admin/integrations/merchants', { params });
    return data;
  },
  async getMerchant(id) {
    const { data } = await adminApi.get(`/api/admin/integrations/merchants/${id}`);
    return data;
  },
  async approveMerchant(id) {
    const { data } = await adminApi.post(`/api/admin/integrations/merchants/${id}/approve`);
    return data;
  },
  async rejectMerchant(id, reason) {
    const { data } = await adminApi.post(`/api/admin/integrations/merchants/${id}/reject`, { reason });
    return data;
  },
  async disableMerchant(id) {
    const { data } = await adminApi.post(`/api/admin/integrations/merchants/${id}/disable`);
    return data;
  },
  async listMerchantCompanies(id) {
    const { data } = await adminApi.get(`/api/admin/integrations/merchants/${id}/companies`);
    return data;
  },
  async addMerchantCompany(id, companyId) {
    const { data } = await adminApi.post(`/api/admin/integrations/merchants/${id}/companies`, { companyId });
    return data;
  },
  async removeMerchantCompany(id, companyId) {
    const { data } = await adminApi.delete(`/api/admin/integrations/merchants/${id}/companies/${companyId}`);
    return data;
  },
  async listMerchantApiKeys(id) {
    const { data } = await adminApi.get(`/api/admin/integrations/merchants/${id}/api-keys`);
    return data;
  },
  async revokeApiKey(id, keyId) {
    const { data } = await adminApi.post(`/api/admin/integrations/merchants/${id}/api-keys/${keyId}/revoke`);
    return data;
  },
  async getMerchantUsage(id, params = {}) {
    const { data } = await adminApi.get(`/api/admin/integrations/merchants/${id}/usage`, { params });
    return data;
  }
};

export default integrationAdminApi;
